import { render, staticRenderFns } from "./Rezultate.vue?vue&type=template&id=f9f96f7c&scoped=true&"
import script from "./Rezultate.vue?vue&type=script&lang=js&"
export * from "./Rezultate.vue?vue&type=script&lang=js&"
import style0 from "./Rezultate.vue?vue&type=style&index=0&id=f9f96f7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f96f7c",
  null
  
)

export default component.exports